import React from 'react';
import { Container } from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { IAnnounce } from '../../../utils/AnnounceInterfaces';
import SearchResultHome from '../../Search/components/SearchResultHome';

const useStyles = makeStyles((theme: any) => ({
    title: {
        color: "#890608",
        fontSize: 24,
        marginBottom: 25,
        marginTop: 20
    },
}));

const typeFilters: Record<string, string[]> = {
    apts: ["Appartement", "Maison", "Suite", "Chambre"],
    htls: ["Hôtel"],
    cars: ["Citadine", "Berline", "SUV", "Utilitaire"],
    rstt: ["Appartement à louer", "Maison à louer", "Bureau à louer", "Terrain en vente", "Maison en vente", "Grand espace en vente", "Salle de fêtes"],
    trs: ["Attraction", "Restaurant", "Musée", "Site historique", "Spas", "nightlife", "Parc naturel"]

};

const searchTypeTitles: Record<string, string> = {
    apts: 'ambassadorListings.title', //'home.hot-location',
    htls: 'home.hot-hotels',
    cars: 'home.hot-cars',
    rstt: 'home.hot-real-estate',
    evts: 'home.hot-events',
    trs: 'home.hot-tours',
};

interface AfriqHomeCardProps {
    announces: IAnnounce[];
    user: any;
    changingFav: boolean;
    loadingItem?: string[];
    onAddToFavorite: (id: string) => void;
    onRemoveToFavorite: (id: string) => void;
    searchTypeName: "cars" | "apts" | "htls" | "trs" | "evts" | "rstt";
    usage: string;
    commissionFee?: number;
}

const AfriqHomeCard: React.FC<AfriqHomeCardProps> = ({
    announces,
    user,
    changingFav,
    loadingItem,
    onAddToFavorite,
    onRemoveToFavorite,
    searchTypeName,
    usage,
    commissionFee
}) => {
    const [loadingItemState, setLoadingItemState] = React.useState<string[]>(loadingItem || []);
    const classes = useStyles();
    const { t } = useTranslation<'common'>(); 

    const filteredAnnounces = announces.filter((announce) => 
        typeFilters[searchTypeName]?.includes(announce.property?.type?.name)
    );

    return (
        <div style={{ display: "flex", justifyContent: "center" }}>
            <Container>
                {usage === "hotelCarousel"
                ? ""
                :
                    <h2 className={classes.title}>
                        {t(searchTypeTitles[searchTypeName] || '')}
                    </h2>
                }   
                <SearchResultHome
                    announces={filteredAnnounces}
                    user={user}
                    changingFav={changingFav}
                    loadingItem={loadingItemState}
                    onAddToFavorite={onAddToFavorite}
                    onRemoveToFavorite={onRemoveToFavorite}
                    searchTypeName={searchTypeName}
                    usage={usage}
                    commissionFee={commissionFee}
                />
            </Container>
        </div>
    );
};

export default AfriqHomeCard;
